var ProductVersion = /*@__PURE__*/ (function () {
    function ProductVersion(data) {
        if (data) {
            if (data.id) {
                this.id = parseInt(data.id, 10);
            }
            if (data.label) {
                this.label = data.label;
            }
            if (data.additional) {
                this.additional = data.additional;
            }
        }
        this.attributes = [];
    }
    ProductVersion.prototype.addAttribute = function (attribute) {
        this.attributes.push(attribute);
    };
    return ProductVersion;
}());
export { ProductVersion };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/product/product.version.ts
// module id = null
// module chunks = 